import React, { useMemo } from "react";
import { api } from "@shared-server/api";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Legend,
} from "recharts";

interface PromptCountInChatsProps {
  startDate: Date;
  endDate: Date;
}

const BUCKETS = [
  { label: "1", min: 1, max: 1 },
  { label: "2-3", min: 2, max: 3 },
  { label: "4-5", min: 4, max: 5 },
  { label: "6-10", min: 6, max: 10 },
  { label: "11-15", min: 11, max: 15 },
  { label: "15+", min: 16, max: Infinity },
];

export const PromptCountInChats = (props: PromptCountInChatsProps) => {
  const coreMetricsQuery = api.coreMetrics.promptsCountPerChat.useQuery({
    startDate: props.startDate,
    endDate: props.endDate,
  });

  const chartData = useMemo(() => {
    const data = coreMetricsQuery.data as Record<string, number> | undefined;
    if (!data) return [];

    const buckets: Record<string, number> = {};
    for (const bucket of BUCKETS) {
      buckets[bucket.label] = 0;
    }

    for (const [countStr, chatsCount] of Object.entries(data)) {
      const count = Number(countStr);
      const bucket = BUCKETS.find((b) => count >= b.min && count <= b.max);
      if (bucket) {
        buckets[bucket.label] = (buckets[bucket.label] ?? 0) + chatsCount;
      }
    }

    return BUCKETS.map((b) => ({
      bucket: b.label,
      chats: buckets[b.label],
    }));
  }, [coreMetricsQuery.data]);

  return (
    <div>
      <h2 className="mb-2 mt-8">{"Prompts count in chats"}</h2>
      <ResponsiveContainer width="100%" height={250}>
        <BarChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="bucket" />
          <YAxis allowDecimals={false} />
          <Tooltip />
          <Legend />
          <Bar dataKey="chats" fill="#006e96" name="Chats" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
